export default {
    bindings: {
        content: '<'
    },
    controller: 'customiseController',
    template: require('../views/customise.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/checkout/components/customise.component.js